<template>
  <ul class="links">
    <li v-for="(link, i) in globals?.social[0]?.item">
      <a :href="link.url" :target="link.target">
        <AppLink :style="{ '--index': i }">
          {{ link?.text }}
        </AppLink>
      </a>
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({});
const globals = useGlobal();
</script>

<style lang="scss" scoped>
.links {
  color: currentColor;
}

.links li:not(:last-child) {
  padding-bottom: 0.2em;
}
</style>
